document.addEventListener('DOMContentLoaded', function () {
document.querySelectorAll('.sql-ugc__video').forEach(function (video) {
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) {
        video.pause();
      }
    });
  }, { threshold: 0.25 });

  observer.observe(video);
});

  document.querySelectorAll('[data-sql-carousel]').forEach(function (root) {
    var slides = root.querySelectorAll('.sql-carousel__slide');
    if (!slides.length) return;
    var idx = 0;
    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
    }
    var prev = root.querySelector('.sql-carousel__prev');
    var next = root.querySelector('.sql-carousel__next');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
  });

  document.querySelectorAll('[data-sql-testimonials]').forEach(function (root) {
    var items = root.querySelectorAll('.sql-testimonial');
    var dotsWrap = root.querySelector('.sql-testimonials__dots');
    if (!items.length || !dotsWrap) return;
    items.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show testimonial ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', function () {
        items.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
        dotsWrap.querySelectorAll('button').forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
      });
      dotsWrap.appendChild(dot);
    });
  });

  document.querySelectorAll('.sql-hero__video, .sql-ugc__video').forEach(function (v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  });
});
